export default __webpack_public_path__ + "static/media/a008-7.3e0fdd27.svg";